import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Box, Paragraph, TextButton } from '@telus-uds/components-web';
import palette from '@telus-uds/palette-koodo';
import Icons from '@telus-uds/palette-koodo/build/web/icons';
import { Drawer } from '../Drawer/Drawer';
import { RichText } from '../RichText/RichText';
export var CPODetailsPanel = function (_a) {
    var title = _a.title, description = _a.description;
    var triggerRef = React.useRef();
    var buttonRef = React.useRef(null);
    var pink = palette.color.pink;
    return (_jsxs(_Fragment, { children: [_jsx(TextButton, { ref: buttonRef, onPress: function () { var _a; return (_a = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _a === void 0 ? void 0 : _a.openDrawer(); }, testID: "cpo-details-text-button", children: title }), _jsx(Drawer, { ref: triggerRef, triggerElements: buttonRef, children: _jsx(Box, { children: _jsx(Paragraph, { children: description && (_jsx(RichText, { content: description, color: { heading: 'brand' }, openLinksInNewTab: true, listOptions: {
                                item: {
                                    icon: Icons.Check,
                                    iconColor: pink.value,
                                    iconSize: 16
                                }
                            } })) }) }) })] }));
};
export default CPODetailsPanel;
